import { programByCode, type LoyaltyProgram } from '@voll-intelligence/domain';
import type { FlightCheckoutItem } from './checkout_legs.js';

/** As companhias do carrinho de voo, na ordem dos trechos (ida, volta, cada
 *  trecho do multi): as de `carriers` e, no card que não as traz, a do segmento. */
function carriersOf(items: readonly FlightCheckoutItem[]): string[] {
  return items.flatMap(({ detail }) => [
    ...(detail.carriers?.outbound ?? [detail.outbound.carrier]),
    ...(detail.return ? (detail.carriers?.return ?? [detail.return.carrier]) : []),
  ]);
}

/**
 * Os programas de fidelidade que valem para o voo (#5340): um por PROGRAMA, não
 * por companhia — LATAM e uma associada (LA, JJ) caem no mesmo LATAM Pass, que
 * aparece uma vez. Companhia fora do catálogo não tem linha.
 */
export function flightLoyaltyPrograms(items: readonly FlightCheckoutItem[]): LoyaltyProgram[] {
  const programs = new Map<string, LoyaltyProgram>();
  for (const code of carriersOf(items)) {
    const program = programByCode('air', code.trim().toUpperCase());
    if (program && !programs.has(program.id)) programs.set(program.id, program);
  }
  return [...programs.values()];
}
